import { useMemo, useState } from "react";
import Breadcrumb from "@/components/feature/Breadcrumb";
import NewsListItem from "@/components/feature/NewsListItem";
import Pagination from "@/components/feature/Pagination";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { formatDate, newsArticles } from "@/lib/content";

const PAGE_SIZE = 6;

export default function News() {
  useDocumentMeta({
    title: "影视资讯 - 夜无疆影视大全",
    description:
      "夜无疆影视资讯频道，汇集行业动态、票房快报、影展消息与深度专访，按时间倒序更新，助你掌握最新影视动态。",
    keywords: "影视资讯,影视新闻,票房快报,影视动态,影展消息,夜无疆资讯",
  });

  const [page, setPage] = useState(1);

  const sorted = useMemo(
    () => [...newsArticles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)),
    []
  );

  const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const current = Math.min(page, totalPages);
  const paged = sorted.slice((current - 1) * PAGE_SIZE, current * PAGE_SIZE);

  return (
    <div className="w-full animate-fadeIn">
      <div className="border-b border-background-200/70 bg-background-100/40 px-4 py-8 md:px-6 lg:px-10 lg:py-10">
        <Breadcrumb items={[{ label: "首页", href: "/" }, { label: "影视资讯" }]} />
        <h1 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">影视资讯</h1>
        <p className="mt-3 max-w-3xl text-sm leading-7 text-foreground-600 md:text-base">
          这里汇集影视行业的最新动态、票房与档期消息、影展资讯以及主创专访。内容按发布时间倒序排列，点击标题即可阅读全文。
        </p>
      </div>

      <div className="w-full px-4 py-8 md:px-6 lg:px-10 lg:py-10">
        <div className="mb-4 flex items-center justify-between">
          <span className="text-xs text-foreground-500">共 {sorted.length} 条资讯 · 按时间倒序</span>
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-sort-desc" />
            最新优先
          </span>
        </div>

        {paged.length > 0 ? (
          <div className="space-y-4">
            {paged.map((item) => (
              <NewsListItem
                key={item.id}
                id={item.id}
                title={item.title}
                publishDate={formatDate(item.publishDate)}
                source={item.source}
                summary={item.summary}
                cover={item.cover}
              />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300/70 bg-background-100/50 px-6 py-16 text-center">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200/70 text-2xl text-foreground-500">
              <i className="ri-newspaper-line" />
            </span>
            <p className="mt-4 text-sm text-foreground-700">暂无影视资讯内容，请稍后再来查看。</p>
            <button
              type="button"
              onClick={() => setPage(1)}
              className="mt-5 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label text-background-50 transition-colors duration-200 hover:bg-primary-600"
            >
              返回第一页
            </button>
          </div>
        )}

        <Pagination current={current} total={totalPages} onChange={setPage} />
      </div>
    </div>
  );
}